module.exports = __webpack_public_path__ + "img/piggy-bank.a345cc84.svg";